if (!customElements.get('testimonial-slider')) {
  class TestimonialSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.testimonial-slider-track');
      this.viewport = this.querySelector('.testimonial-slider-viewport');
      this.slides = this.querySelectorAll('.testimonial-slide');
      this.prevBtn = this.querySelector('.testimonial-prev');
      this.nextBtn = this.querySelector('.testimonial-next');
      this.currentIndex = 0;
      this.slideCount = this.slides.length;
      this.resizeId = 0;

      if (this.slideCount <= 1) {
        this.prevBtn.style.display = 'none';
        this.nextBtn.style.display = 'none';
      }

      this.prevBtn.addEventListener('click', () => this.go(this.currentIndex - 1));
      this.nextBtn.addEventListener('click', () => this.go(this.currentIndex + 1));

      this.dragStartX = 0;
      this.dragging = false;
      this.viewport.addEventListener('touchstart', (e) => { this.dragStartX = e.changedTouches[0].screenX; }, { passive: true });
      this.viewport.addEventListener('touchend', (e) => {
        var diff = this.dragStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) this.go(diff > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      });
      this.viewport.addEventListener('mousedown', (e) => { this.dragging = true; this.dragStartX = e.screenX; });
      this.viewport.addEventListener('mouseup', (e) => {
        if (!this.dragging) return;
        this.dragging = false;
        var diff = this.dragStartX - e.screenX;
        if (Math.abs(diff) > 40) this.go(diff > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      });
      this.viewport.addEventListener('mouseleave', () => { this.dragging = false; });
      this.viewport.style.cursor = 'grab';

      this.layout();

      var self = this;
      this.querySelectorAll('img').forEach(function(img) {
        if (!img.complete) img.addEventListener('load', function() { self.layout(); }, { once: true });
      });

      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(function() {
          self.syncHeight();
        });
        if (self.slides[self.currentIndex]) self._ro.observe(self.slides[self.currentIndex]);
      }

      window.addEventListener('resize', function() {
        clearTimeout(self.resizeId);
        self.resizeId = setTimeout(function() {
          self.viewport.style.height = '';
          self.layout();
        }, 80);
      });
    }

    layout() {
      if (!this.slideCount) return;
      var gap = window.innerWidth >= 1000 ? 38 : window.innerWidth >= 750 ? 30 : 12;
      var spv = window.innerWidth >= 750 ? 1.1 : 1;
      var vw = this.viewport.offsetWidth;
      this.slideW = spv <= 1 ? vw : (vw - gap * Math.floor(spv)) / spv;
      this.gap = gap;
      this.vw = vw;

      var last = this.slideCount - 1;
      var w = this.slideW + 'px';
      this.slides.forEach(function(s, i) {
        s.style.width = w;
        s.style.flexShrink = '0';
        s.style.marginRight = i === last ? '0px' : gap + 'px';
      });

      this.moveTo();
    }

    go(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.slideCount - 1));
      if (this._ro && this.slides[this.currentIndex]) {
        this._ro.disconnect();
        this._ro.observe(this.slides[this.currentIndex]);
      }
      this.moveTo();
    }

    moveTo() {
      var step = this.slideW + this.gap;
      var total = this.slideCount * this.slideW + (this.slideCount - 1) * this.gap;
      var max = Math.max(0, total - this.vw);
      this.track.style.transform = 'translateX(-' + Math.min(this.currentIndex * step, max) + 'px)';
      this.syncHeight();
    }

    syncHeight() {
      if (window.innerWidth > 1000 && this.slides[this.currentIndex]) {
        this.viewport.style.transition = 'height 0.4s ease';
        this.viewport.style.height = this.slides[this.currentIndex].offsetHeight + 'px';
      } else {
        this.viewport.style.transition = '';
        this.viewport.style.height = '';
      }
    }
  }

  customElements.define('testimonial-slider', TestimonialSlider);
}
